<template>
    <div class="row">
        <div class="col-xl-6">
            <div class="creator-title mt-0">{{ $t("Írd be a szöveget") }}:</div>

            <div id="sticker-text">
                <div
                    class="form-floating mb-2"
                    v-for="index in rowIndexes"
                    v-bind:key="'rows-' + index"
                    :id="'sticker-text' + index"
                >
                    <div class="input-status">
                        {{ textLength(model.text[index]) }} / {{ maxLength }}
                    </div>
                    <input
                        type="text"
                        :value="model.text[index]"
                        v-on:input="setText(index, $event.target.value)"
                        class="form-control mb-2"
                        :id="'text-' + index"
                        :placeholder="
                            $t('Szöveg') + ' ' + (index + 1) + $t('. sor')
                        "
                        :maxlength="maxLength"
                    />
                    <label :for="'text-' + index">{{
                        $t("Szöveg") + " " + (index + 1) + $t(". sor")
                    }}</label>
                </div>
            </div>
        </div>
        <div class="col-xl-6">
            <div class="creator-title mt-xl-0">
                {{ $t("Válassz betűszínt") }}:
            </div>
            <ul class="color-rounds" id="colorSwitcher">
                <li
                    v-for="(item, index) in colors"
                    v-bind:key="'text-color-' + index"
                >
                    <input
                        type="radio"
                        name="text-color"
                        :id="'color-' + item.id"
                        :checked="model.textColor === item.hexa"
                        v-on:change="$emit('update', { textColor: item.hexa })"
                    />
                    <label
                        :for="'color-' + item.id"
                        class="d-block"
                        :title="item.name"
                        :aria-label="item.name"
                    >
                        <div
                            class="round"
                            :data-color="item.hexa"
                            :style="'background-color: ' + item.hexa"
                        ></div>
                    </label>
                </li>
            </ul>
        </div>
        <div class="col-xl-12">
            <div class="creator-title">{{ $t("Válassz betűtípust") }}:</div>

            <div class="text-danger small" role="alert" v-if="missing.length">
                {{
                    $t(
                        "A választott betűtípus nem tartalmazza ezeket a betűket:"
                    )
                }}
                <strong>{{ missing.join(" ") }}</strong
                >.
                {{ $t("Válassz másik betűtípust.") }}
            </div>
            <ul class="item-list" id="fontFamily">
                <li
                    :style="'font-family:' + item.name"
                    v-for="(item, index) in fonts"
                    v-bind:key="'fonts-' + index"
                >
                    <input
                        type="radio"
                        name="font"
                        :id="'fonts-' + index"
                        :checked="model.selectedFont === item.name"
                        v-on:change="
                            $emit('update', { selectedFont: item.name })
                        "
                    />
                    <label :for="'fonts-' + index">
                        <span>{{ fontLabel(item.name) }}</span>
                    </label>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { stickerRows } from "@/lib/sticker/render";
import {
    normalizeFamily,
    loadFont,
    missingCharacters
} from "@/lib/sticker/fonts";

export default {
    name: "TabText",
    props: ["sticker", "model", "colors", "fonts"],
    data() {
        return {
            maxLength: 18,
            missing: []
        };
    },
    watch: {
        fontCheck: {
            immediate: true,
            handler() {
                const family = this.model.selectedFont;
                const texts = this.model.text.slice(
                    0,
                    stickerRows(this.sticker)
                );
                loadFont(family).then(font => {
                    if (family === this.model.selectedFont) {
                        this.missing = missingCharacters(font, texts);
                    }
                });
            }
        }
    },
    computed: {
        fontCheck() {
            return [this.model.selectedFont, ...this.model.text].join("|");
        },
        rowIndexes() {
            return [...Array(stickerRows(this.sticker)).keys()];
        }
    },
    methods: {
        setText(index, value) {
            const text = this.model.text.slice();
            text[index] = value;
            this.$emit("update", { text });
        },
        textLength(value) {
            return value ? value.length : 0;
        },
        fontLabel(name) {
            return normalizeFamily(name);
        }
    }
};
</script>

<style scoped></style>
